import axios, { AxiosResponse } from 'axios';
import { STORE_URL } from '../integrations/woocommerce/api';

export interface OrderAddressPayload {
  first_name: string;
  last_name: string;
  address_1: string;
  address_2?: string;
  city: string;
  postcode: string;
  country: string;
  email?: string;
  phone?: string;
}

export interface OrderLineItemPayload {
  product_id: number;
  quantity: number;
}

export interface CreateOrderPayload {
  payment_method: 'cod' | 'bacs' | 'webxpay';
  payment_method_title: string;
  set_paid: boolean;
  customer_id?: number;
  billing: OrderAddressPayload;
  shipping: Omit<OrderAddressPayload, 'email' | 'phone'>;
  line_items: OrderLineItemPayload[];
}

export interface WooOrderResponse {
  id: number;
  status?: string;
  order_key?: string;
  customer_id?: number;
  [key: string]: unknown;
}

export interface WebxpayPaymentLinkResponse {
  payment_url: string;
  fields?: Record<string, string | number | boolean | null | undefined>;
}

export const createOrderApi = (orderData: CreateOrderPayload): Promise<AxiosResponse<WooOrderResponse>> => {
  // Build a clean payload — only include customer_id if it's a positive integer.
  // WooCommerce REST API treats customer_id=0 as a guest, and will ignore
  // non-integer values. We strip it entirely if invalid to avoid ambiguity.
  const { customer_id, ...rest } = orderData;

  const isValidCustomerId =
    typeof customer_id === 'number' &&
    Number.isInteger(customer_id) &&
    customer_id > 0;

  const requestBody: CreateOrderPayload = isValidCustomerId
    ? { ...rest, customer_id }
    : { ...rest };

  // console.log(
  //   '[API] createOrderApi — customer_id in request body:',
  //   requestBody.customer_id ?? 'NOT SET (guest order)'
  // );

  return axios.post<WooOrderResponse>(
    `${STORE_URL}/wp-json/nex/v1/orders`,
    requestBody,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
};

export const getWebxpayPaymentLinkApi = (
  orderId: number,
  orderKey: string,
): Promise<AxiosResponse<WebxpayPaymentLinkResponse>> => {
  return axios.post<WebxpayPaymentLinkResponse>(
    `${STORE_URL}/wp-json/nex/v1/get-payment-link`,
    { order_id: orderId, order_key: orderKey },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );
};
